import type { HttpService } from './http-service';
import type { MxApplicationService } from './mx-application-service';
import { FeatureTrackingType, FeatureTrackingUseCases } from '../../Shell/PandoraSolutionBuilderAgent/model/enumerations';

/**
 * @ngdoc service
 * @name MxFeatureTrackingService
 * @module mx.shell
 *
 * @requires {@ref mx.shell.MxApplicationService mx.shell.MxApplicationService}
 *
 * @description
 * A service tracking a feature use from the client side.
 */
export class MxFeatureTrackingService {
	static readonly $inject = ['mx.shell.Http', 'mx.shell.AppsService'];

	constructor(
		private readonly httpService: HttpService,
		private readonly appsService: MxApplicationService
	) {}

	public track(feature: FeatureTrackingType, useCase: FeatureTrackingUseCases, appName: string | null = null) {
		const applicationName = appName ?? this.appsService.getCurrentApplication().name;

		this.httpService.post('api/FeatureTracking', {
			feature: feature,
			useCase: useCase,
			application: applicationName,
		});
	}
}
